import { vuetifyColors, getContrastYIQ } from '@/utils/themes';
export default {
  name: 'CoreSnackBar',
  computed: {
    snackbar() {
      return this.$store.state.app.snackbar;
    },
    textColor() {
      const color = vuetifyColors[this.snackbar.color] || '#000';
      return getContrastYIQ(color);
    }
  },
  methods: {
    close() {
      this.$store.state.app.snackbar = {
        ...this.$store.state.app.snackbar,
        model: false
      };
    }
  }
};